import type { SVGProps } from "react";
// generated from AlignRight.svg — do not edit manually
// prettier-ignore
export default function AlignRight(props: SVGProps<SVGSVGElement>) {
  return (<svg viewBox="0 0 24 24" fill="none"
  xmlns="http://www.w3.org/2000/svg" {...props}>
  <path d="M9 12H21M3 6H21M3 18H21" stroke="currentColor" strokeWidth="1.5"/>
</svg>);
}
